export default __webpack_public_path__ + "static/media/PlayStation.c2852af7.svg";